import React, { Component } from 'react';
import "./Resume.css";

class Motorola extends Component {
    render() {
        return (

            <div className="Motorola">
                        <h2 className="text-center">Motorola Mobility 12/00 - 12/12</h2>
                        <hr/>
                        <p>My duties as a software engineer at Motorola included creating new software modules
                            for bringing up new set top box platforms, providing input for third party industry
                            standards, refactoring legacy software modules, and fixing bugs discovered in legacy
                            software during stability testing.</p>
                        <p>Highlights:</p>
                        <ul>

                            <li>Created the MHP EIT data gathering engine and class library. This multi-threaded
                                C++ library made use of the publisher-subscriber and reference counting design
                                patterns. </li>

                            <li>Created the Motorola template library that allows applications to use template
                                instantiations create by the middleware while prohibiting applications from
                                creating instantiations. </li>

                            <li>Created a training course and was the technical liaison when Motorola's
                                DVB code base was transferred from the US to India and Tiawan. This three
                                month course enabled the offshore teams to double Motorola's presence in
                                    the European DVB market</li>

                            <li>Created a tool application that allows back-tracing of a Linux application
                                run on a set tip box. The tool parses the Linux ELF library modules as well
                                    as information contained in the /proc file system running on the Linux platform.</li>

                            <li>Created an event logging application that meets the requirements of the
                                first three normal forms of database design. This multi-threaded C++ library
                                makes use of the Resource Allocation Is Initialization (RAII) and Private
                                Implimentation (Pimpl) design pattern idioms, the Monostate design pattern,
                                and has one parameter manipulator objects that allow code such as
                                "cout &lt;&lt; DebugData(AnyObject) &lt;&lt; endl;" to be used anywhere in the code
                                    for debugging any Object.</li>

                        </ul>
                        </div>


            
        );
    }
} 

export default Motorola;





// WEBPACK FOOTER //
// ./src/components/Resume/Motorola.js